import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE;

const Profile = () => {
  const navigate = useNavigate();
  const userEmail = localStorage.getItem("userEmail") || "";
  const [userData, setUserData] = useState({
    name: "",
    lastName: "",
    email: "",
    profilePicture: null,
  });

  useEffect(() => {
    if (!userEmail) return;
    axios
      .get(`${API_BASE}/api/customers/user-profile/${userEmail}`)
      .then((res) => setUserData(res.data))
      .catch((err) => console.error("❌ Failed to load profile:", err));
  }, [userEmail]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const handleProfileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("profilePicture", file);
    formData.append("email", userEmail);
    try {
      const res = await axios.post(`${API_BASE}/api/customers/upload-profile-picture`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.profilePicture) {
        setUserData((prev) => ({ ...prev, profilePicture: res.data.profilePicture }));
      }
    } catch (err) {
      console.error("❌ Upload failed:", err);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center text-gray-900 font-sans">
      {/* Header */}
      <h1 className="text-lg font-semibold border-b w-full text-center py-4">Profile</h1>

      {/* Profile Photo */}
      <div className="flex flex-col items-center mt-6 mb-2">
        <div
          className="w-24 h-24 rounded-full overflow-hidden border border-gray-300 cursor-pointer"
          onClick={() => document.getElementById("profileUpload").click()}
        >
          {userData.profilePicture ? (
            <img
              src={`${API_BASE}${userData.profilePicture}`}
              alt="Profile"
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="flex items-center justify-center h-full bg-gray-100 text-3xl font-bold text-gray-400">
              {userData.name?.[0] || "?"}
            </div>
          )}
        </div>
        <input
          id="profileUpload"
          type="file"
          accept="image/*"
          onChange={handleProfileUpload}
          className="hidden"
        />
        <h2 className="mt-3 text-[17px] font-semibold">
          {userData.name} {userData.lastName?.charAt(0) || ""}
        </h2>
      </div>

      {/* Account Info */}
      <div className="w-full max-w-md mt-4 border-t border-gray-200">
        <div className="flex justify-between items-center px-6 py-3 border-b border-gray-100">
          <span className="font-medium">Account</span>
          <span className="text-gray-500">{userData.email}</span>
        </div>

        <div
          onClick={() => navigate("/change-password")}
          className="flex justify-between items-center px-6 py-3 border-b border-gray-100 cursor-pointer hover:bg-gray-50"
        >
          <span className="font-medium">Change Password</span>
          <span className="text-gray-400">›</span>
        </div>

        <div
          onClick={() => navigate("/help")}
          className="flex justify-between items-center px-6 py-3 border-b border-gray-100 cursor-pointer hover:bg-gray-50"
        >
          <span className="font-medium">Support</span>
          <span className="text-gray-400">›</span>
        </div>

        <div
          onClick={() => navigate("/about")}
          className="flex justify-between items-center px-6 py-3 border-b border-gray-100 cursor-pointer hover:bg-gray-50"
        >
          <span className="font-medium">About</span>
          <span className="text-gray-400">›</span>
        </div>

        <a
          href="https://worker.bookyourneed.com"
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-between items-center px-6 py-3 border-b border-gray-100 cursor-pointer hover:bg-gray-50"
        >
          <span className="font-medium">Become a Worker</span>
          <span className="text-gray-400">›</span>
        </a>

        <div
          onClick={handleLogout}
          className="text-center text-red-600 font-semibold py-4 cursor-pointer hover:bg-gray-100"
        >
          Log Out
        </div>
      </div>
    </div>
  );
};

export default Profile;
